import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { useAuthState } from '../../../../../contexts'
import { useEmbed } from '../../../../../hooks'
import { useEmbedPrefills } from '../../../../../hooks/prefills/use-embed-prefills'
import { useAssociateEmbedSubmissionMutation } from '../../../../../modules/flexApi'
import { logger } from '../../../../../providers'
import * as Routes from '../../../../../routing/constants'
import { FullScreenSpinnerLoading } from '../../../../components'

export const EmbedAuthContainer = () => {
  const navigate = useNavigate()
  const { client, token } = useEmbed()
  const [associateEmbedSubmission] = useAssociateEmbedSubmissionMutation()
  const { uid } = useAuthState()
  const { handlePrefill } = useEmbedPrefills()
  const nextRoute = Routes.Onboarding.CREATE_ACCOUNT

  const handleAssociateEmbedSubmission = (customerId: string) => {
    try {
      return associateEmbedSubmission({ customerId, client, token })
    } catch (error: any) {
      logger.warn('EmbedAuthContainer', `Error associating embed submission: ${error?.message}`)
    }
  }

  const redirectToCreateAccount = async () => {
    try {
      await handleAssociateEmbedSubmission(uid!)
      await handlePrefill({
        navigateToAddressSelection: () => navigate(nextRoute, { replace: true }),
      })
      navigate(nextRoute, { replace: true })
    } catch (error) {
      navigate(Routes.Onboarding.CREATE_ACCOUNT, { replace: true })
    }
  }

  useEffect(() => {
    redirectToCreateAccount()
  }, [])

  return <FullScreenSpinnerLoading />
}
